import React from 'react';
import styled from 'styled-components';
import { Color } from '~common/model/basics';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const Logo: React.FunctionComponent<IconProps> = ({ width = 103, height = 34, ...rest }) => (
  <DropShadowIcon
    width={width}
    height={height}
    viewBoxHeight={66}
    viewBoxWidth={200}
    color={Color.Transparent}
    {...rest}
  >
    <path
      d="M177.825 0C165.602 0 155.65 9.94389 155.65 22.1752V35.9862H142.512C145.542 32.1968 147.354 27.3975 147.354 22.1752C147.354 9.94389 137.41 0 125.179 0C112.956 0 103.004 9.94389 103.004 22.1752C103.004 27.3975 104.817 32.1968 107.846 35.9862H90.997C94.0268 32.1968 95.8394 27.3975 95.8394 22.1752C95.8481 9.94389 85.9042 0 73.6815 0C61.4502 0 51.5063 9.94389 51.5063 22.1752C51.5063 27.3975 53.3189 32.1968 56.3487 35.9862H29.9353L48.5369 0H39.1196L24.7562 27.8032L9.5382 0H0L20.1208 36.7544L5.26543 65.5158H14.6741L25.6107 44.3418H155.65V65.5158H164.014V44.3418H177.825C190.047 44.3418 200 34.3979 200 22.1666C200 9.94389 190.056 0 177.825 0ZM111.368 22.1752C111.368 14.5619 117.566 8.36426 125.179 8.36426C132.792 8.36426 138.99 14.5619 138.99 22.1752C138.99 29.7885 132.792 35.9862 125.179 35.9862C117.566 35.9862 111.368 29.7885 111.368 22.1752ZM59.8705 22.1752C59.8705 14.5619 66.0682 8.36426 73.6815 8.36426C81.2948 8.36426 87.4924 14.5619 87.4924 22.1752C87.4924 29.7885 81.2948 35.9862 73.6815 35.9862C66.0596 35.9862 59.8705 29.7885 59.8705 22.1752ZM177.825 35.9862H164.014V22.1752C164.014 14.5619 170.211 8.36426 177.825 8.36426C185.438 8.36426 191.636 14.5619 191.636 22.1752C191.636 29.7885 185.447 35.9862 177.825 35.9862Z"
      fill="#8222FF"
    />
    <path d="M170.634 35.9862H164.014V44.3505H170.634V35.9862Z" fill="url(#paint0_linear)" />
    <path d="M155.658 35.9862H149.038V44.3505H155.658V35.9862Z" fill="url(#paint1_linear)" />
    <path
      d="M42.011 35.9862H29.9351L25.6191 44.3418H37.1858L42.011 35.9862Z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M103.237 18.9901C103.09 20.0259 103.004 21.0876 103.004 22.1666C103.004 27.3889 104.817 32.1882 107.846 35.9776H125.179C117.566 35.9776 111.368 29.7799 111.368 22.1666C111.368 21.0704 111.506 20.0086 111.757 18.9901H103.237Z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M149.392 35.9862H142.512C138.446 41.079 132.188 44.3505 125.179 44.3505H149.383V35.9862H149.392Z"
      fill="url(#paint4_radial)"
    />
    <path
      d="M51.7394 18.9901C51.5927 20.0259 51.5063 21.0876 51.5063 22.1666C51.5063 27.3889 53.319 32.1882 56.3488 35.9776H73.6816C66.0683 35.9776 59.8706 29.7799 59.8706 22.1666C59.8706 21.0704 60.0087 20.0086 60.259 18.9901H51.7394Z"
      fill="url(#paint5_linear)"
    />
    <path
      d="M97.8852 35.9862H91.0056C86.94 41.079 80.6819 44.3505 73.6729 44.3505H97.8766V35.9862H97.8852Z"
      fill="url(#paint6_radial)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="163.094"
        y1="40.1644"
        x2="170.635"
        y2="40.1644"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F0050" stopOpacity="0.7" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="156.579"
        y1="40.1644"
        x2="149.038"
        y2="40.1644"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F0050" stopOpacity="0.7" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="25.6538"
        y1="36.2653"
        x2="35.0386"
        y2="40.7492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F0050" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="114.096"
        y1="36.937"
        x2="114.096"
        y2="18.9925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F0050" stopOpacity="0.7" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint4_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(130.543 39.1114) scale(19.1982)"
      >
        <stop stopColor="#1F0050" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint5_linear"
        x1="62.5923"
        y1="36.937"
        x2="62.5923"
        y2="18.9925"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F0050" stopOpacity="0.7" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint6_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(79.0401 39.1114) scale(19.1982)"
      >
        <stop stopColor="#1F0050" />
        <stop offset="1" stopColor="#200051" stopOpacity="0" />
      </radialGradient>
    </defs>
  </DropShadowIcon>
);

const DropShadowIcon = styled(Icon)`
  filter: drop-shadow(
    0 2px 4px ${(props): string => props.theme.colors.withAlpha(props.theme.colors.black)(0.6)}
  );
`;



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/components/icon/logo.icon.tsx